import { render, staticRenderFns } from "./banner7.vue?vue&type=template&id=7127ace0&scoped=true&"
import script from "./banner7.vue?vue&type=script&lang=js&"
export * from "./banner7.vue?vue&type=script&lang=js&"
import style0 from "./banner7.vue?vue&type=style&index=0&id=7127ace0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7127ace0",
  null
  
)

export default component.exports